import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useNavigate } from "react-router-dom";

// Standard brand imports
import brand_1 from "../../assets/1.png";
import brand_2 from "../../assets/2.png";
import brand_3 from "../../assets/3.png";
import brand_4 from "../../assets/4.png";
import brand_5 from "../../assets/5.png";
import brand_6 from "../../assets/6.png";
import brand_7 from "../../assets/7.png";
import brand_8 from "../../assets/8.png";
import brand_9 from "../../assets/9.png";
import brand_10 from "../../assets/10.png";
import brand_11 from "../../assets/11.png";
import brand_12 from "../../assets/12.png";

gsap.registerPlugin(ScrollTrigger);

const logosRow1 = [
  { id: 1, img: brand_1, link: "/fragrance?vendor=Adrienne" },
  { id: 2, img: brand_2, link: "/fragrance?vendor=Burberry" },
  { id: 3, img: brand_3, link: "/fragrance?vendor=Calvin" },
  { id: 4, img: brand_4, link: "/fragrance?vendor=Azzaro" },
  { id: 5, img: brand_5, link: "/fragrance?vendor=Armaf" },
  { id: 6, img: brand_6, link: "/fragrance?vendor=Carolina" },
];

const logosRow2 = [
  { id: 7, img: brand_7, link: "/fragrance?vendor=Bvlgari" },
  { id: 8, img: brand_8, link: "/fragrance?vendor=Versace" },
  { id: 9, img: brand_9, link: "/fragrance?vendor=Cartier" },
  { id: 10, img: brand_10, link: "/fragrance?vendor=Clinique" },
  { id: 11, img: brand_11, link: "/fragrance?vendor=Christian" },
  { id: 12, img: brand_12, link: "/fragrance?vendor=Adrienne" },
];

const Brands = () => {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);

  useEffect(() => {
    // Parallax Scroll - Row 1 slides left
    gsap.to(row1Ref.current, {
      xPercent: -20,
      ease: "none",
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top bottom",
        end: "bottom top",
        scrub: 1.5,
      },
    });

    // Parallax Scroll - Row 2 slides right
    gsap.to(row2Ref.current, {
      xPercent: 20,
      ease: "none",
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top bottom",
        end: "bottom top",
        scrub: 1.5,
      },
    });

    return () => {
      ScrollTrigger.getAll().forEach((st) => st.kill());
    };
  }, []);

  const swiperOptions = {
    modules: [Autoplay],
    slidesPerView: "auto",
    spaceBetween: 80, // More breathing room for larger images
    loop: true,
    speed: 6000, // Slightly slower for a more premium "gallery" feel
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
  };

  return (
    <section 
      ref={sectionRef} 
      className="bg-white py-24 md:py-40 overflow-hidden w-full border-y border-gray-100"
    >
      {/* Header - Simple & Clean */}
      <div className="w-full text-center mb-24 px-6">
        <h2 className="font-syne text-4xl md:text-7xl font-bold text-black uppercase tracking-tight product-tabs">
          Elite Curation
        </h2>
      </div>

      {/* Row 1 */}
      <div ref={row1Ref} className="mb-16">
        <Swiper {...swiperOptions} className="linear-swiper">
          {[...logosRow1, ...logosRow1].map((logo, idx) => (
            <SwiperSlide key={idx} style={{ width: 'auto' }}>
              <BrandLogo logo={logo} navigate={navigate} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Row 2 */}
      <div ref={row2Ref}>
        <Swiper 
          {...swiperOptions} 
          autoplay={{ ...swiperOptions.autoplay, reverseDirection: true }}
          className="linear-swiper"
        >
          {[...logosRow2, ...logosRow2].map((logo, idx) => (
            <SwiperSlide key={idx} style={{width: 'auto' }}>
              <BrandLogo logo={logo} navigate={navigate} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .linear-swiper .swiper-wrapper {
          transition-timing-function: linear !important;
        }
      `}} />
    </section>
  );
};

const BrandLogo = ({ logo, navigate }) => (
  <div 
    onClick={() => navigate(logo.link)}
    className="flex justify-center items-center cursor-pointer group px-8"
  >
    <img
      src={logo.img}
      alt="brand"
      // h-16 for mobile, h-24 for desktop as requested
      className="h-16 md:h-24 w-auto object-contain grayscale group-hover:grayscale-0 transition-all duration-500 ease-out group-hover:scale-125"
    />
  </div>
);

export default Brands;